module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-mobile-03-09115b0b6dd6b3b51b1bffb9142d322f.jpg";